export default __webpack_public_path__ + "static/media/05.cad04f59.jpg";